import { useStore } from "vuex";
import { PartialCategoryDocument } from "@/types/category.ts";
import { mapDocToPartialCategory } from "@/components/CategoryLayouts/mapDocToCategory.ts";
import { Categories } from "@/types/categories.ts";

export default function useCategoriesGetters() {
  const store = useStore();
  function get(): Categories | undefined {
    if (!store.state.api.categories.categories) {
      return undefined;
    }
    return {
      ...store.state.api.categories,
      categories: store.state.api.categories.categories.map(
        (category: PartialCategoryDocument) =>
          mapDocToPartialCategory(category, store.getters.getTouchScreen)
      ),
    };
  }
  return {
    get,
  };
}
